import isEqual from 'lodash/isEqual'
import alertMutations from 'optinmonster-js-library/src/vue/campaigns/store/alerts/mutations'
import { arrayIt, dates, objects } from '@/utils'

export const notificationExists = (notifications, payload) => {
	payload = objects.simplify(payload)
	delete payload.id
	delete payload.created

	const index = notifications.findIndex(notice => {
		try {
			const testNotice = objects.simplify(notice)
			delete testNotice.id
			delete testNotice.created

			return isEqual(payload, testNotice)
		} catch (e) {
			return false
		}
	})

	return -1 !== index
}

const addNotification = (notifications, payload) => {
	if (!payload.created) {
		payload.created = dates.timestamp()
	}

	let position = 'bottom'
	if (payload.position) {
		position = 'top' === payload.position ? 'top' : 'bottom'
		delete payload.position
	}

	notifications['bottom' === position ? 'push' : 'unshift'](payload)

	return notifications
}

export default {
	...alertMutations,
	removeNotifications (state, payload) {
		const notifications = [ ...state.notifications ]
		const ids = arrayIt(payload)
		ids.forEach((id) => {
			const index = state.notifications.findIndex(n => n.id === id)
			notifications.splice(index, 1)
		})
		this._vm.$set(state, 'notifications', notifications)
	},
	setNotifications (state, payload) {
		const notifications = state.queue.concat(arrayIt(payload)).map(n => {
			if (!n.created) {
				n.created = dates.timestamp()
			}
			return n
		})
		this._vm.$set(state, 'notifications', notifications)
		this._vm.$set(state, 'set', true)
		if (state.error) {
			this._vm.$set(state, 'error', null)
			alertMutations.closeAlerts(state)
		}
	},
	setEnabled (state, payload) {
		this._vm.$set(state, 'enabled', Boolean(payload))
	},
	add (state, payload) {
		const { notifications, queue } = state

		this._vm.$set(state, 'notifications', addNotification(notifications, payload))
		if (!state.set) {
			this._vm.$set(state, 'queue', addNotification(queue, payload))
		}
	},
	maybeAdd (state, payload) {
		const { notifications, queue } = state

		if (notificationExists(notifications, payload)) {
			return false
		}

		this._vm.$set(state, 'notifications', addNotification(notifications, payload))
		if (!state.set) {
			this._vm.$set(state, 'queue', addNotification(queue, payload))
		}
	},
	remove (state, payload) {
		const index = state.notifications.findIndex(n => n === payload)
		this._vm.$delete(state.notifications, index)
	},
}
